import Vue from 'vue';

export const patientsPortalStore = Vue.observable({
    executeAction: null,
    updatedAt: null,
    selectedItem: null,
    selectedPatientCodeList: null
});
